import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["value", "style", "className"];
import React, { useId } from 'react';
import { forwardRef } from 'react';
import { RootNode } from './node';
import { jsx as _jsx } from "react/jsx-runtime";
export * from './node';
export * from './value';
export * from './semicolon';
var JsonView = /*#__PURE__*/forwardRef((props, ref) => {
  var {
      value,
      style,
      className
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var defaultStyle = _extends({
    lineHeight: 1.4,
    fontFamily: 'var(--w-rjv-font-family, Menlo, monospace)',
    color: 'var(--w-rjv-color, #002b36)',
    backgroundColor: 'var(--w-rjv-background-color, #00000000)',
    fontSize: 13
  }, style);
  var cls = "w-json-view-container w-rjv " + (className || '');
  var keyid = useId();
  return /*#__PURE__*/_jsx(RootNode, _extends({
    className: cls,
    value: value
  }, reset, {
    ref: ref,
    keyid: keyid,
    style: defaultStyle
  }));
});
JsonView.displayName = 'JVR.JsonView';
export default JsonView;